class AjouterRessourceRequest {
  titre: string;
  description: string;
  resume: string;
  categorie: string;
  estActif: boolean;
  fichier: File | null;
  fichiers: File[];

  constructor({
    titre = '',
    description = '',
    resume = '',
    categorie = '',
    estActif = true,
    fichier = null,
    fichiers = [],
  }: Partial<{
    titre: string;
    description: string;
    resume: string;
    categorie: string;
    estActif: boolean;
    fichier: File | null;
    fichiers: File[];
  }> = {}) {
    this.titre = titre;
    this.description = description;
    this.resume = resume;
    this.categorie = categorie;
    this.estActif = estActif;
    this.fichier = fichier;
    this.fichiers = fichiers;
  }

  toFormData() {
    const formData = new FormData();
    formData.append('Titre', this.titre);
    formData.append('Description', this.description);
    formData.append('Resume', this.resume || '');
    formData.append('Categorie', this.categorie);
    formData.append('EstActif', String(this.estActif));

    if (this.fichier) {
      formData.append('Fichier', this.fichier);
    }

    const fichiers = Array.isArray(this.fichiers) ? this.fichiers : [];
    fichiers.forEach((fichier) => {
      if (fichier) {
        formData.append('Fichiers', fichier);
      }
    });

    return formData;
  }
}

export default AjouterRessourceRequest;
